import { render, staticRenderFns } from "./SubitemTree.vue?vue&type=template&id=2adcbfbb"
import script from "./SubitemTree.vue?vue&type=script&lang=js"
export * from "./SubitemTree.vue?vue&type=script&lang=js"
import style0 from "./SubitemTree.vue?vue&type=style&index=0&id=2adcbfbb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports